export default "__VITE_ASSET__DCDxPHED__"